import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../actions'
import { doTrack } from '../../helpers/TaggingSerializer'

import Svg from '@argos/svg'
import LoadingError from '../../components/LoadingError/LoadingError'
import Sidebar from '../../components/Sidebar/Sidebar'
import Meta from '../../components/Meta/Meta'
import StarRating from '../../components/StarRating/StarRating'
import LiveChat from '../../components/LiveChat/LiveChat'
import SearchBar from '../../components/SearchBar/SearchBar'

import pdfSvg from '../../static/img/product-care/pdf.svg'

import './ProductCare.scss'

class MonthlyCare extends PureComponent {
  static waitForDataServer (dispatch, params, req, res) {
    return Promise
      .all([
        dispatch(actions.fetchSidebarNav(true)),
        dispatch(actions.fetchPageContent('monthly-care', true))
      ])
      .then(([sidebar, page]) => {
        if (page.payload.id === 0) {
          res.statusCode = 404
        }
      })
  }

  static waitForDataClient (store) {
    return (nextState, transition, callback) => {
      const { dispatch, getState } = store
      const state = getState()
      const page = state.page.page

      if (page && page.permalink === '/help/monthly-care/') {
        return callback()
      }

      dispatch(actions.fetchPageContent('monthly-care'))
        .then(() => { callback() })
        .catch(() => { callback() })
    }
  }

  componentDidMount () {
    const { actions, sidebar } = this.props

    if (!sidebar.length) actions.fetchSidebarNav()
    this.fireAnalytics()
  }

  fireAnalytics = () => {
    if (window.digitalData) {
      window.digitalData.page.pageInfo.pageName = 'ar:help:page:productcare:monthlycare'
      window.digitalData.page.pageInfo.templateTitle = 'help_PAGE_productcare'
    }

    doTrack('help_initialLoad')
  }

  render () {
    const ccn = 'product-care'
    const { sidebar, page, error } = this.props

    if (!page || error) return <LoadingError />

    return (
      <div className={`${ccn} helpfaq font-standard page`}>
        <div id='helpfaqcontent' tabIndex='-1' />

        <Meta pagemeta={page} />

        <div className='container sticky-nav'>
          <div className='xs-row xs-row--negative lg-row'>
            <Sidebar activePage='/help/monthly-care/' links={sidebar} sticky />
          </div>
        </div>

        <div className='sticky-content'>
          <div className={'container'}>
            <div className='xs-row'>
              <div className='xs-12 lg-9 lg-3-offset'>
                <div className={`${ccn}-subpage__header ${ccn}-subpage__header--monthly`}>
                  <h1 className={`${ccn}-subpage__title`}>
                    Monthly Care
                  </h1>
                </div>

                <h2 className={`${ccn}__subheading h2`}>Peace of mind, paid monthly</h2>
                <p>The perfect way to get all the benefits of Argos Monthly Care, provided by Domestic &amp; General, but you can pay as you go. You'll be covered for accidental damage, as well as for faults, theft or breakdowns (even longer than your manufacturer's guarantee).</p>
                <p>If we can't repair it, we'll replace it with a brand new one, or we'll give you the equivalent value in Argos vouchers, so you can pick out your own.</p>

                <div className={`${ccn}__cover-types-section xs-row xs-row--negative`}>
                  <div className={`${ccn}-cover-type xs-12 md-6`}>
                    <div className={`${ccn}-cover-type__content`}>
                      <div className={`${ccn}-cover-type__title`}>So, what's included?</div>
                      <ul className='list-unstyled list-ticks'>
                        <li>Immediate worldwide accidental damage cover</li>
                        <li>Worldwide breakdown cover, after your manufacturer's guarantee ends</li>
                        <li>Unlimited repairs of your product</li>
                        <li>And if we can't fix it... A brand new replacement or equivalent Argos vouchers</li>
                        <li>Technical support for up to four computers in your home</li>
                        <li>The cost of replacing accessories included with the original item</li>
                        <li>Theft with force or due to break-ins (mobile phones only)</li>
                      </ul>
                    </div>
                  </div>

                  <div className={`${ccn}-cover-type xs-12 md-6`}>
                    <div className={`${ccn}-cover-type__content`}>
                      <div className={`${ccn}-cover-type__title`}>And what's not included?</div>
                      <ul className='list-unstyled list-cross'>
                        <li>Loss, neglect, cosmetic &amp; deliberate damage including damage caused by animals</li>
                        <li>The cost of accessories not included with the original item</li>
                        <li>Theft or attempted theft of appliances and household goods</li>
                        <li>Theft without force, including pickpocketing (mobile phones only)</li>
                        <li>You'll need to pay an excess for mobile phones worth £150 or more</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='background-color-cerulean text-color-white'>
            <div className={`${ccn}__section ${ccn}__section--details container`}>
              <div className='xs-row'>
                <div className='xs-12 lg-9 lg-3-offset'>
                  <p className={`${ccn}__title ${ccn}__title--white`}>Now, for the finer details...</p>

                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12 md-6'>
                      <p>For more information about Argos Monthly Breakdown Care, you can download the Insurance Product Information Document and leaflet below...</p>
                    </div>

                    <div className='xs-12 md-6'>
                      <div className='xs-row xs-row--negative'>
                        <div className={`${ccn}__pdf xs-6`}>
                          <Svg aria-hidden='true'>{pdfSvg}</Svg>
                          <a className={`${ccn}__pdf-link`} href='//documents.4rgos.it/v1/static/690247_IPID' target='_blank'>Download IPID</a>
                        </div>
                        <div className={`${ccn}__pdf xs-6`}>
                          <Svg aria-hidden='true'>{pdfSvg}</Svg>
                          <a className={`${ccn}__pdf-link`} href='//documents.4rgos.it/v1/static/690247_leaflet' target='_blank'>Download Ts&amp;Cs</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${ccn}__section container`}>
            <div className='xs-row'>
              <div className='xs-12 lg-9 lg-3-offset'>
                <h2 className={`${ccn}__subheading h2`}>There's still time... 45 days in fact</h2>
                <div className='xs-row xs-row--negative'>
                  <div className={`${ccn}__45days-image xs-12 md-4`}>
                    <img src='/helpfaq-assets/static/img/product-care/45-days.png' width='110' alt='' />
                  </div>

                  <div className='xs-12 md-8'>
                    <p>Still not quite sure if you want Argos Monthly Care? You've got 45 days from the date you buy your item to get that extra reassurance.</p>
                    <p>Just pop into store with your receipt in hand and one of our friendly colleagues will be happy to help. You can buy it right-then-and-there and you'll be covered right away. Phew, that's a relief!</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='background-color-grey-light'>
            <div className={`${ccn}__section ${ccn}__section--claim container`}>
              <div className='xs-row'>
                <div className='xs-12 lg-9 lg-3-offset'>
                  <h2 className={`${ccn}__subheading h2`}>Making a claim - we're here for you</h2>
                  <div className='xs-row xs-row--negative'>
                    <div className='xs-12 md-8'>
                      <p>The true test of any insurance is when you need to make a claim. With Argos Monthly Care, it couldn't be simpler.</p>
                      <p>Just give us a call on <span className='font-bold'>0800 4970655</span> and have your policy number and postcode to hand.</p>
                      <p>In the unfortunate event that your mobile phone has been stolen, please report the incident to the Police immediately and request a Crime Reference Number. Then you just need to call us on 0800 497 0655 to make a claim.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${ccn}__section container`}>
            <div className='xs-row'>
              <div className='xs-12 lg-9 lg-3-offset'>
                <h2 className={`${ccn}__subheading h2`}>Compare your Product Care</h2>
                <div className='xs-row xs-row--negative'>
                  <div className={`${ccn}__compare-logo xs-12 md-3`}>
                    <img src='/helpfaq-assets/static/img/product-care/compareextendedwarranties.png' width='170' height='90' alt='Compare Extended Warranties logo' />
                  </div>

                  <div className='xs-12 md-9'>
                    <p>We've worked hard with our insurance provider to make sure that with Argos Monthly Care, you can have peace of mind if the unexpected happens.</p>
                    <p>But, don't just take our word for it... The Competition and Markets Authority has created a handy, unbiased website where you can check our cover against other insurers.</p>
                    <div className={`${ccn}__link--large`}>
                      <a className='button-link button-link--large' href='http://compareextendedwarranties.co.uk/' target='_blank'>Compare Argos Monthly Care now</a>
                    </div>
                  </div>
                </div>

                <h2 className={`${ccn}__subheading h2`}>
                  Buy yourself more time with the Argos Card.<br />
                  Representative 29.9% APR Variable
                </h2>
                <div className={`${ccn}__afs-promo xs-row xs-row--negative`}>
                  <div className='xs-12 md-7'>
                    <p>Don't forget you can pay for Product Care with the Argos Card (as well as the item you're actually buying). You even could roll both onto one Buy Now Pay Later plan to spread the cost. Now that's super-smart.</p>
                    <div className={`${ccn}__link--large`}>
                      <a className='button-link button-link--large' href='/help/argos-card/'>Apply for an Argos Card</a>
                    </div>
                    <div className={`${ccn}__link--large`}>
                      <a className='button-link button-link--large' href='/'>Shop now with my Argos Card</a>
                    </div>
                  </div>

                  <div className={`${ccn}__45days-image xs-12 md-5`}>
                    <img src='/helpfaq-assets/static/img/product-care/argos-card.png' width='230' alt='' />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='background-color-grey-light'>
            <div className={`${ccn}__section ${ccn}__section--legal container`}>
              <div className='xs-row'>
                <div className='xs-12 lg-9 lg-3-offset'>
                  <p className='font-base--small'>You won't be charged any interest if you pay off your plan within the Pay Later period and keep your account up to date. If you don't pay off your plan before it ends, you'll be charged interest at your normal plan rate from the date of purchase. However, if you choose to make payments without clearing the balance, the earlier you pay the less interest you'll be charged. Credit subject to status.</p>
                  <p className='font-base--small'>Argos Limited is authorised and regulated by the Financial Conduct Authority as a credit broker, and works exclusively with the Argos Card lender, Home Retail Group Card Services Limited.</p>
                  <br />
                  <p className='font-base--small'>Argos Monthly Care is provided by Domestic &amp; General Insurance PLC. Registered Office: Swan Court, 11 Worple Road, Wimbledon, London SW19 4JS. Registered in England and Wales. Company No. 485850.</p>
                  <p className='font-base--small'>Domestic &amp; General Insurance PLC is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority.</p>
                </div>
              </div>
            </div>
          </div>

          <div className='container'>
            <div className='xs-row lg-row'>
              <div className='xs-12 lg-9 lg-3-offset'>

                <StarRating pageId={page.id} />

                <LiveChat
                  actions={this.props.actions}
                  chatHasEnded={this.props.chatHasEnded}
                  chatLoading={this.props.chatLoading}
                  chatOnline={this.props.chatOnline}
                />

                <SearchBar position='bottom' />

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

MonthlyCare.propTypes = {
  sidebar: PropTypes.array,
  page: PropTypes.object,
  error: PropTypes.bool,
  actions: PropTypes.object,
  chatHasEnded: PropTypes.bool,
  chatLoading: PropTypes.bool,
  chatOnline: PropTypes.bool
}

function mapStateToProps (state) {
  return {
    sidebar: state.help.sidebar,
    page: state.page.page,
    error: state.page.pageError,
    chatHasEnded: state.page.chatHasEnded,
    chatLoading: state.page.chatLoading,
    chatOnline: state.page.chatOnline
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyCare)
